import React, { useState } from 'react';
import StripeCheckout from 'react-stripe-checkout';
import axios from 'axios';
import './App.css'; // ton ancien fichier CSS

function App() {
  const [selectedProductId, setSelectedProductId] = useState('');
  const [productInfo, setProductInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Produits
  const products = {
    product1: { price: 199.99, title: "Indicateur Daily" },
    product2: { price: 299.99, title: "Indicateur 4h/1h" },
    product3: { price: 499.99, title: "Indicateur 15mn" },
  };

  // Clé publique Stripe
  const stripePublicKey = "pk_live_51SHrNN6F2MN0GuWwbkICsBgLoRs9p9xRnuBo5Up4H6IDcyvCb1W22N7OjPsratwXZoC388hbpqrLdpuycN1oEA2o00AC5hBuXb";

  // Sélection du produit
  const handleProductSelection = (event) => {
    const id = event.target.value;
    setSelectedProductId(id);
    setProductInfo(id ? products[id] : null);
  };

  // Paiement Stripe
  const handlePayment = async (token) => {
    setLoading(true);
    try {
      const response = await axios.post('/api/payment', {
        token: token.id,
        productId: selectedProductId,
        amount: Math.round(productInfo.price * 100), // Stripe attend les montants en cents
      });

      if (response.data.success) {
        alert('✅ Paiement réussi !');
        window.location.href = '/Delivrance_IndicateurD.html';
      } else {
        setErrorMessage('Erreur lors du paiement.');
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('Une erreur est survenue lors du paiement.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <div className="parallax-container">
        {/* 🎬 Vidéo de fond */}
        <video id="video-background" autoPlay loop muted>
          <source
            src="https://gateway.pinata.cloud/ipfs/QmPZ8v3KzeyH2Dqz29TZFWe4kswkUETJyesZFCFULtagwv"
            type="video/mp4"
          />
          Votre navigateur ne supporte pas les vidéos HTML5.
        </video>

        <div className="content">
          <div className="payment-wrapper">
            <h1>Les Indicateurs à Levier</h1>

            {productInfo && (
              <div>
                <p>Produit choisi : {productInfo.title}</p>
                <p>Prix : {productInfo.price} USD</p>
              </div>
            )}

            <select
              key={selectedProductId || 'empty'}
              onChange={handleProductSelection}
              value={selectedProductId}
            >
              <option value="">Sélectionnez un produit</option>
              <option value="product1">Indicateur Daily</option>
              <option value="product2">Indicateur 4h/1h</option>
              <option value="product3">Indicateur 15mn</option>
            </select>

            {productInfo && (
              <StripeCheckout
                stripeKey={stripePublicKey}
                token={handlePayment}
                amount={Math.round(productInfo.price * 100)}
                name={productInfo.title}
                description={`Achetez ${productInfo.title}`}
                currency="USD"
                billingAddress
                shippingAddress
              >
                <button disabled={loading}>
                  {loading ? 'Traitement...' : 'Payer avec Stripe'}
                </button>
              </StripeCheckout>
            )}

            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
